import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { processNodes } from "react-html-parser"

export const RenderFontAwesome = (node, transform) => {
  if (node.attribs.class === "fontawesome-icon-inline") {
    const iTag = node.children.filter((element) => element.name === "i").shift()
    const iTagClass = iTag?.attribs?.class?.split(" ")
    let size = null
    const attributes = {}
    attributes.transform = ""
    if (iTagClass) {
      iTagClass.map((element) => {
        switch (element) {
          case "fa-inverse":
            attributes.inverse = true
            break
          case "fa-fw":
            attributes.fixedWidth = true
            break
          case "fa-border":
            attributes.border = true
            break
          case "fa-spin":
            attributes.spin = true
            break
          case "fa-pulse":
            attributes.pulse = true
            break
          case "fa-pull-left":
            attributes.pull = "left"
            break
          case "fa-pull-right":
            attributes.pull = "right"
            break
          case "fa-xs":
            size = "xs"
            break
          case "fa-sm":
            size = "sm"
            break
          case "fa-lg":
            size = "lg"
            break
          case "fa-2x":
            size = "2x"
            break
          case "fa-3x":
            size = "3x"
            break
          case "fa-4x":
            size = "4x"
            break
          case "fa-5x":
            size = "5x"
            break
          case "fa-6x":
            size = "6x"
            break
          case "fa-7x":
            size = "7x"
            break
          case "fa-8x":
            size = "8x"
            break
          case "fa-9x":
            size = "9x"
            break
          case "fa-10x":
            size = "10x"
            break
          default:
            break
        }
        return element
      })
    }
    if (node.attribs.style && node.attribs.style.includes("color")) {
      const tabStyle = node.attribs.style.split(": ")
      const color = tabStyle[1].slice(0, -1)
      attributes.color = color
    }
    const iconParameters = iTagClass
      ? [iTagClass[0], iTagClass[1].slice(3)]
      : []
    const newChildren = node.children.filter((element) => element !== iTag)
    return (
      <>
        <FontAwesomeIcon icon={iconParameters} size={size} {...attributes} />
        {processNodes(newChildren ? newChildren : node.children, transform)}
      </>
    )
  }
}

RenderFontAwesome.propTypes = {
  node: PropTypes.object,
  transform: PropTypes.func,
}
